<template>
  <div class="paymentWrapper">
    <div class="paymentBox">
      <div class="header">
        Payment
      </div>
      <div class="summary">
        <div class="price">
          $29
        </div>
        <div class="description">
          <div class="line-item">
            <i class="material-icons" style="color: #FF006B;font-size: 15px;">
              check_circle
            </i>
            <div class="line-item__text">3 Months Access</div>
          </div>
          <div class="line-item">
            <i class="material-icons" style="color: #FF006B;font-size: 15px;">
              check_circle
            </i>
            <div class="line-item__text">Unlimited lesson support</div>
          </div>
          <div class="line-item">
            <i class="material-icons" style="color: #FF006B;font-size: 15px;">
              check_circle
            </i>
            <div class="line-item__text">30-Day Money-Back Guarantee</div>
          </div>
        </div>

      </div>
      <div class="paymentContainer">
        <card class='stripeElements'
          :class='{ complete }'
          v-bind:stripe='stripeKey'
          :options='stripeOptions'
          @change='complete = $event.complete'
        />

        <div v-if="isPaying">
          <img src="/static/img/icons/spinner-200px.gif" />
        </div>
        <ChoiceConfirm
          v-if="!isPaying"
          v-bind:disabled="!complete"
          v-on:click="pay"
          v-bind:style="{ width: '100%'}"
          id="pay-button"
          >
        Pay Now
        </ChoiceConfirm>
        <div class="stripeIcon">
          <!--
          <img width="80px" src="/static/landing/assets/money-back.jpg" class="media media--image"/>
          -->
          <img src="/static/img/icons/powered_by_stripe.png" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import { Card, createToken } from 'vue-stripe-elements-plus'
import { makePayment } from '../utils/battles-api'

export default {
  data () {

    return {
      complete: false,
      stripeKey: process.env.STRIPE_PUBLIC_KEY,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      isPaying: false
    }
  },

  components: { Card },
  methods: {
    /*
    getStarted () {
      this.$router.push({ path: 'home' })
    },
    */
    pay () {

      if (!this.complete) {
        alert("Please enter your payment details")
        return
      }

      this.isPaying = true

      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken().then((data) => {
        if (!data.token) {
          alert("Sorry, something unexpected happened, please contact support")
          this.isPaying = false
          console.log("No token", data)
        }

        makePayment(data.token.id).then(user => {
          gtag_report_conversion()
          this.isPaying = false
          // Set User - redirect to home
          this.$store.commit('setUser', user)
          // need better hasPaid method
          this.$router.push({ path: 'home' })
          //this.paymentSubmitted = true
        }).catch(error => {
          alert("Sorry, something unexpected happened")
          this.isPaying = false
          console.log(error)
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.stripeIcon{
  width: 322px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

@media (max-width: 600px) {
  .stripeIcon{
    width: 95%;
  }
}
.description{
  display: flex;
  flex-direction: column;
}
.line-item{
  text-align: left;
  font-family: 'Roboto', sans-serify;
  font-size: 15px;
  line-height: 16px;
  color: #484848;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0.07em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.line-item__text{
  padding-left: 10px;
}
.price{
  font-weight: bold;
  font-size: 27px;
  color: #484848;
}

.paymentContainer{
  display: flex;
  flex-direction: column;
  height: 150px;

  align-items: center;
  justify-content: space-between;
  text-align: center;
}

@media (max-width: 600px) {
  .paymentContainer{
    width: 100%;
  }
}

.stripeElements {
  width: 322px;
  height: 50px;

  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 13px;
}
@media (max-width: 600px) {
  .stripeElements{
    width: 95%;
  }
}

.payButton{
  width: 322px;
  height: 60px;

  background: #FF006B;
  border-radius: 3px;

  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15em;

  color: #FFFFFF;
}

.stripe-card.complete {
  border-color: green;
}

.header{
  height: 74px;
  border-bottom: 1px solid #FAFAFA;
  width: 100%;

  text-transform: uppercase;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.15em;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
  text-align: center;
}

.summary{
  width: 322px;
  height: 74px;
  font-family: 'Roboto', sans-serify;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
@media (max-width: 600px) {
  .summary{
    width: 95%;
  }
}


.paymentWrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10vh 10vw;
  padding-bottom: 14vh;
}

.paymentBox{
  width: 406px;
  height: 350px;

  background: #FFFFFF;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.11);

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: flex-start;
  text-align: center;
}

@media (max-width: 600px) {
  .paymentBox{
    width: 100%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Payment.vue